/* ============================================================
   ORIVO — Mullein Purifier · interactivity (real Shopify cart)
   ============================================================ */
(function () {
  "use strict";

  /* ---------- Shopify config (from #orivoConfig data-attrs) ---------- */
  var CFG = (function () {
    var el = document.getElementById("orivoConfig");
    var d = (el && el.dataset) || {};
    return {
      cartAdd: d.cartAdd || "/cart/add",
      cartUrl: d.cartUrl || "/cart",
      afterAdd: d.afterAdd || "drawer",
      variants: { t1: (d.vT1 || "").trim(), t2: (d.vT2 || "").trim(), t3: (d.vT3 || "").trim() },
      protection: (d.protection || "").trim(),
      saleHours: parseInt(d.saleHours, 10) || 5
    };
  })();

  /* ---------- Config / data (single source of truth) ---------- */
  var FREE_SHIP_THRESHOLD = 1239;     // Rand — spend this much to unlock free shipping
  var PROTECTION_FEE = 49;            // Rand
  var SALE_HOURS = CFG.saleHours || 5;   // countdown window (from settings)

  var TIERS = [
    { id: "t1", name: "Starter — 30 Day Lung Reset", supply: "1 Pen · 30 Day Supply",  qty: 1, price: 699,  compare: 1098, offer: "Buy 1" },
    { id: "t2", name: "60 Day Deep Cleanse", supply: "2 Pens · 60 Day Supply", qty: 2, price: 1239, compare: 3095, badge: "Most Popular", offer: "Buy 2" },
    { id: "t3", name: "120 Day Full Reset", supply: "4 Pens · 120 Day Supply", qty: 4, price: 2199, compare: 4893, badge: "Best Value", offer: "Buy 3, Get 1 Free" }
  ];

  /* variant id -> { compare (Rand), offer } for cart savings display */
  var VMAP = {};
  TIERS.forEach(function (t) { var vid = (CFG.variants[t.id] || "").trim(); if (vid) VMAP[String(vid)] = { compare: t.compare, offer: t.offer }; });

  var state = {
    tierIndex: 2,            // default: Best Value (3rd bundle) pre-selected
    protection: false,
    cart: []                 // {tier}
  };

  /* ---------- Money ---------- */
  function money(n) {
    return "R" + Math.round(n).toLocaleString("en-US");
  }

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ============================================================
     COUNTDOWN (persistent, datetime-based)
     ============================================================ */
  function getSaleEnd() {
    var key = "orivo_sale_end_5h";
    var stored = parseInt(localStorage.getItem(key), 10);
    var now = Date.now();
    if (!stored || isNaN(stored) || stored < now) {
      stored = now + SALE_HOURS * 3600 * 1000;
      try { localStorage.setItem(key, String(stored)); } catch (e) {}
    }
    return stored;
  }

  function initCountdowns() {
    var end = getSaleEnd();
    var groups = $$("[data-countdown]");
    function pad(n) { return (n < 10 ? "0" : "") + n; }
    var timer;
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        groups.forEach(function (g) {
          var wrap = g.closest("[data-cd-wrap]") || g;
          var fb = wrap.querySelector("[data-cd-expired]");
          g.style.display = "none";
          if (fb) fb.style.display = "";
        });
        clearInterval(timer);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      groups.forEach(function (g) {
        var set = function (k, v) { var el = g.querySelector("[data-cd='" + k + "']"); if (el) el.textContent = pad(v); };
        set("d", d); set("h", h); set("m", m); set("s", s);
      });
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ============================================================
     LIVE VIEWER COUNT
     ============================================================ */
  function initViewers() {
    var els = $$("[data-viewers]");
    if (!els.length) return;
    var n = 26 + Math.floor(Math.random() * 12);
    function render() { els.forEach(function (el) { el.textContent = n; }); }
    render();
    setInterval(function () {
      n += Math.floor(Math.random() * 5) - 2;
      if (n < 18) n = 18; if (n > 44) n = 44;
      render();
    }, 4500);
  }

  /* ============================================================
     GALLERY
     ============================================================ */
  function initGallery() {
    var stage = $("#galStage");
    if (!stage) return;
    var slides = $$(".gal-slide", stage);
    var thumbs = $$(".gal-thumb");
    var i = 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { if (k === i) s.setAttribute("data-active", ""); else s.removeAttribute("data-active"); });
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute("data-active", ""); else t.removeAttribute("data-active"); });
    }
    $("#galPrev").addEventListener("click", function () { go(i - 1); });
    $("#galNext").addEventListener("click", function () { go(i + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener("click", function () { go(k); }); });
    go(0);
  }

  /* ============================================================
     BUNDLE TIERS + PRICE SYNC
     ============================================================ */
  function selectedTier() { return TIERS[state.tierIndex]; }

  function selectedVariant() { var t = selectedTier(); return CFG.variants[t.id] || ""; }

  function syncOffer() {
    var t = selectedTier();
    var vInput = document.getElementById("orivoVariantInput");
    if (vInput) vInput.value = selectedVariant();
    $$(".tiers .tier").forEach(function (card, idx) {
      if (idx === state.tierIndex) card.setAttribute("data-selected", ""); else card.removeAttribute("data-selected");
      card.setAttribute("aria-checked", idx === state.tierIndex ? "true" : "false");
    });
    var atcPrice = $("#atcPrice");
    if (atcPrice) atcPrice.textContent = money(t.price);
    var st = $("#stickyTier"); if (st) st.textContent = t.name + " · " + t.supply;
    var sn = $("#stickyNow"); if (sn) sn.textContent = money(t.price);
    var sWas = $("#stickyWas");
    if (sWas) sWas.textContent = t.compare > t.price ? money(t.compare) : "";
  }

  function initTiers() {
    $$(".tiers .tier").forEach(function (card, idx) {
      card.setAttribute("role", "radio");
      card.setAttribute("tabindex", "0");
      function pick() { state.tierIndex = idx; syncOffer(); }
      card.addEventListener("click", pick);
      card.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); pick(); }
        if (e.key === "ArrowDown" || e.key === "ArrowRight") { e.preventDefault(); state.tierIndex = Math.min(TIERS.length - 1, idx + 1); syncOffer(); $$(".tiers .tier")[state.tierIndex].focus(); }
        if (e.key === "ArrowUp" || e.key === "ArrowLeft") { e.preventDefault(); state.tierIndex = Math.max(0, idx - 1); syncOffer(); $$(".tiers .tier")[state.tierIndex].focus(); }
      });
    });
    syncOffer();
  }

  /* ============================================================
     STICKY ADD-TO-CART (reveal after hero CTA scrolls away)
     ============================================================ */
  function initSticky() {
    var anchor = $("#atcAnchor");
    var bar = $("#stickyAtc");
    if (!anchor || !bar) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) bar.removeAttribute("data-show");
        else if (e.boundingClientRect.top < 0) bar.setAttribute("data-show", "");
        else bar.removeAttribute("data-show");
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ============================================================
     ACCORDION (objection FAQ) — all items start closed
     ============================================================ */
  function initAccordion() {
    $$(".acc__item").forEach(function (item) {
      var q = $(".acc__q", item);
      var a = $(".acc__a", item);
      q.setAttribute("aria-expanded", "false");
      item.removeAttribute("data-open");
      a.style.maxHeight = 0;
      q.addEventListener("click", function () {
        var open = item.hasAttribute("data-open");
        if (open) { item.removeAttribute("data-open"); a.style.maxHeight = 0; q.setAttribute("aria-expanded", "false"); }
        else { item.setAttribute("data-open", ""); a.style.maxHeight = a.scrollHeight + "px"; q.setAttribute("aria-expanded", "true"); }
      });
    });
    window.addEventListener("resize", function () {
      $$(".acc__item[data-open] .acc__a").forEach(function (a) { a.style.maxHeight = a.scrollHeight + "px"; });
    });
  }

  /* ============================================================
     CART DRAWER + FREE SHIPPING BAR  (real Shopify AJAX cart)
     ============================================================ */
  function fmtMoney(cents) { return "R" + Math.round((cents || 0) / 100).toLocaleString("en-US"); }

  function getCart() {
    return fetch(CFG.cartUrl + ".js", { headers: { "Accept": "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); });
  }
  function addItems(items) {
    return fetch(CFG.cartAdd + ".js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function openCart() { var d = $("#cartDrawer"), o = $("#cartOverlay"); if (d) d.setAttribute("data-open", ""); if (o) o.setAttribute("data-open", ""); }
  function closeCart() { var d = $("#cartDrawer"), o = $("#cartOverlay"); if (d) d.removeAttribute("data-open"); if (o) o.removeAttribute("data-open"); }

  function renderShipBar(subCents) {
    var msg = $("#shipMsg"), fill = $("#shipFill");
    if (!fill) return;
    var threshold = FREE_SHIP_THRESHOLD * 100;
    fill.style.width = Math.min(100, Math.round((subCents / threshold) * 100)) + "%";
    if (!msg) return;
    if (subCents >= threshold) { msg.classList.add("done"); msg.innerHTML = "Congrats! You get <b>FREE shipping!</b>"; }
    else { msg.classList.remove("done"); msg.innerHTML = "Spend <b>" + fmtMoney(threshold - subCents) + "</b> more to get FREE shipping!"; }
  }

  function protectionLine(cart) {
    if (!CFG.protection || !cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (String(it.variant_id) === CFG.protection || String(it.id) === CFG.protection) return it;
    }
    return null;
  }
  function syncProtectionToggle(cart) {
    var tg = $("#protectToggle");
    if (!tg) return;
    var row = tg.closest(".protect");
    if (!CFG.protection) { if (row) row.style.display = "none"; return; }
    var on = !!protectionLine(cart);
    if (on) tg.setAttribute("data-on", ""); else tg.removeAttribute("data-on");
    tg.setAttribute("aria-checked", on ? "true" : "false");
  }

  function renderCart(cart) {
    var body = $("#cartBody");
    var sub = (cart && cart.items_subtotal_price != null) ? cart.items_subtotal_price : (cart ? cart.total_price : 0);
    var totalSave = 0;
    if (!cart || !cart.items || cart.items.length === 0) {
      if (body) body.innerHTML = '<div class="cart-empty">Your cart is empty.<br>Choose a bundle to get started.</div>';
      $$("[data-cart-count]").forEach(function (el) { el.textContent = "0"; el.style.display = "none"; });
      if ($("#cartTotal")) $("#cartTotal").textContent = fmtMoney(0);
      var sv0 = $("#cartSavings"); if (sv0) sv0.style.display = "none";
      renderShipBar(0); syncProtectionToggle(null); return;
    }
    if (body) body.innerHTML = cart.items.map(function (l) {
      var img = l.image ? '<img src="' + l.image + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:inherit;">' : phSVG();
      var vinfo = VMAP[String(l.variant_id)];
      var priceUnit = l.quantity ? Math.round(l.final_line_price / l.quantity) : l.final_line_price;
      var tagHtml = "", unitHtml = "", lineHtml = "", saveHtml = "";
      if (vinfo) {
        var compUnit = vinfo.compare * 100;
        var compLine = compUnit * l.quantity;
        var saveC = compLine - l.final_line_price;
        if (saveC > 0) totalSave += saveC;
        tagHtml = '<div class="cart-line__tagrow"><span class="cart-line__tag"><svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><path d="M2 11.5V3h8.5L21 13.5 13.5 21 2 11.5z"/><circle cx="7" cy="7" r="1.7" fill="#fff"/></svg>' + vinfo.offer + '</span></div>';
        unitHtml = '<div class="cart-line__unit"><s>' + fmtMoney(compUnit) + '</s><b>' + fmtMoney(priceUnit) + '</b></div>';
        lineHtml = '<s>' + fmtMoney(compLine) + '</s><span class="now">' + fmtMoney(l.final_line_price) + '</span>';
        if (saveC > 0) saveHtml = '<div class="cart-line__save">You save ' + fmtMoney(saveC) + '</div>';
      } else {
        var was = (l.original_line_price > l.final_line_price) ? '<s>' + fmtMoney(l.original_line_price) + '</s>' : '';
        unitHtml = '<div class="cart-line__unit"><b>' + (priceUnit === 0 ? 'FREE' : fmtMoney(priceUnit)) + '</b></div>';
        lineHtml = was + '<span class="now">' + (l.final_line_price === 0 ? 'FREE' : fmtMoney(l.final_line_price)) + '</span>';
      }
      return '<div class="cart-line">' +
        '<div class="cart-line__ph">' + img + '</div>' +
        '<div class="cart-line__mid"><div class="cart-line__nm">' + l.product_title + '</div>' +
        tagHtml + unitHtml +
        '<div class="cart-qty">' +
          '<button class="cart-qty__b" type="button" data-dec data-key="' + l.key + '" aria-label="Decrease quantity">−</button>' +
          '<span class="cart-qty__n">' + l.quantity + '</span>' +
          '<button class="cart-qty__b" type="button" data-inc data-key="' + l.key + '" aria-label="Increase quantity">+</button>' +
        '</div></div>' +
        '<div class="cart-line__right"><div class="cart-line__price">' + lineHtml + '</div>' + saveHtml +
          '<button class="cart-line__rm" type="button" data-rm data-key="' + l.key + '" aria-label="Remove item">Remove</button>' +
        '</div>' +
        '</div>';
    }).join("");
    if ($("#cartTotal")) $("#cartTotal").textContent = fmtMoney(sub);
    var sv = $("#cartSavings");
    if (sv) { if (totalSave > 0) { sv.style.display = ""; var amt = sv.querySelector(".amt"); if (amt) amt.textContent = "−" + fmtMoney(totalSave); } else { sv.style.display = "none"; } }
    $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count ? "" : "none"; });
    renderShipBar(sub); syncProtectionToggle(cart);
  }

  function refreshCart() { return getCart().then(renderCart).catch(function () {}); }

  function showNotice(msg) { var n = $("#orivoNotice"); if (n) { n.hidden = false; n.textContent = msg; } }
  function clearNotice() { var n = $("#orivoNotice"); if (n) { n.hidden = true; n.textContent = ""; } }

  function addToCart(e) {
    if (e && e.preventDefault) e.preventDefault();
    clearNotice();
    var vid = selectedVariant();
    if (!vid) { showNotice("⚠ Add this bundle's Shopify variant ID in this section's settings to enable checkout."); return; }
    var btns = $$("[data-add-to-cart]");
    btns.forEach(function (b) { b.disabled = true; });
    addItems([{ id: vid, quantity: 1 }]).then(function () {
      if (CFG.afterAdd === "checkout") { window.location.href = "/checkout"; return null; }
      if (CFG.afterAdd === "cart") { window.location.href = CFG.cartUrl; return null; }
      return refreshCart().then(openCart);
    }).catch(function (err) {
      showNotice("Sorry — we couldn't add that to the cart. Check the variant ID is correct and in stock.");
      if (window.console) console.warn("Orivo add-to-cart failed:", err);
    }).then(function () { btns.forEach(function (b) { b.disabled = false; }); });
  }

  function initCart() {
    var form = document.getElementById("orivoBuyForm");
    if (form) form.addEventListener("submit", addToCart);

    var cb = $("#cartBody");
    if (cb) cb.addEventListener("click", function (e) {
      var rm = e.target.closest("[data-rm]");
      if (rm) { changeLine(rm.getAttribute("data-key"), 0).then(renderCart); return; }
      var dec = e.target.closest("[data-dec]");
      if (dec) { var n1 = dec.parentNode.querySelector(".cart-qty__n"); var q1 = (parseInt(n1 && n1.textContent, 10) || 1) - 1; changeLine(dec.getAttribute("data-key"), Math.max(0, q1)).then(renderCart); return; }
      var inc = e.target.closest("[data-inc]");
      if (inc) { var n2 = inc.parentNode.querySelector(".cart-qty__n"); var q2 = (parseInt(n2 && n2.textContent, 10) || 1) + 1; changeLine(inc.getAttribute("data-key"), q2).then(renderCart); return; }
    });

    var co = $("#cartOpen"); if (co) co.addEventListener("click", function () { refreshCart().then(openCart); });
    var cl = $("#cartClose"); if (cl) cl.addEventListener("click", closeCart);
    var ov = $("#cartOverlay"); if (ov) ov.addEventListener("click", closeCart);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

    var chk = $("#cartCheckout"); if (chk) chk.addEventListener("click", function () { window.location.href = "/checkout"; });

    var tg = $("#protectToggle");
    if (tg) tg.addEventListener("click", function () {
      if (!CFG.protection) return;
      getCart().then(function (cart) {
        var line = protectionLine(cart);
        if (line) { return changeLine(line.key, 0).then(renderCart); }
        return addItems([{ id: CFG.protection, quantity: 1 }]).then(refreshCart);
      });
    });

    refreshCart();
  }

  /* ============================================================
     SMOOTH ANCHOR to buy box
     ============================================================ */
  function initAnchors() {
    $$("[data-scroll-buybox]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        var bb = $("#buybox");
        if (bb) window.scrollTo({ top: bb.getBoundingClientRect().top + window.pageYOffset - 80, behavior: "smooth" });
      });
    });
  }

  /* placeholder svg helper (used by cart lines) */
  function phSVG() {
    return '<div class="ph" style="padding:0"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="9.5" y="2.5" width="5" height="14" rx="2.5"/><path d="M12 16.5V21"/></svg></div>';
  }

  /* ---------- boot ---------- */
  function boot() {
    initCountdowns();
    initViewers();
    initGallery();
    initTiers();
    initSticky();
    initAccordion();
    initCart();
    initAnchors();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  // Re-bind handlers when the Shopify theme editor re-renders the section
  document.addEventListener("shopify:section:load", boot);
})();
